var React = require('react');

function CubeLineSecond (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"linearGradient4399","y2":"4490.1","gradientUnits":"userSpaceOnUse","x2":"510.42","gradientTransform":"scale(1.8484 0.541)","y1":"4439.9","x1":"582.66"},[React.createElement("stop",{"stopColor":"#CCB4B4","offset":"0","key":0}),React.createElement("stop",{"stopColor":"#FF8787","offset":"1","key":1})])),React.createElement("polyline",{"transform":"translate(-913,-2378)","stroke":"url(#linearGradient4399)","points":"1076 2378 1076 2425 913 2425","strokeWidth":"2","fill":"none","key":1})]);
}

CubeLineSecond.defaultProps = {"height":"48","width":"164","viewBox":"0 0 164 48","fill":"none","strokeDashoffset":"0","strokeDasharray":"250"};

module.exports = CubeLineSecond;

CubeLineSecond.default = CubeLineSecond;
